import React, { useState, useEffect } from 'react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import Auth from '../Function/Auth';
import { toast, ToastContainer } from "react-toastify";

function Admin() {
    const authToken = sessionStorage.getItem('authToken');
    const baseurl = process.env.REACT_APP_BASE_API_URL;

    const [profileData, setProfileData] = useState("");
    const [masterData, setMasterData] = useState("");
    const [tableLoading, setTableLoading] = useState(false);
    const [adminList, setAdminList] = useState([]);
    const [adminName, setAdminName] = useState('');
    const [adminEmail, setAdminEmail] = useState('');
    const [adminPassword, setAdminPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [adminRole, setAdminRole] = useState('Master Admin');
    const [isAssetLoading, setIsAssetLoading] = useState(false);

    useEffect(() => {
        fetchAssets();
    }, []);

    const handleProfileDataFetched = (data) => {
        setProfileData(data.USER);
        setMasterData(data.MASTERDATA);
    };

    const fetchAssets = async () => {
        try {
            const response = await fetch(`${baseurl}/list`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                }
            });

            const result = await response.json();

            if (result.status) {
                setAdminList(result.data);
            } else {
                toast.error(result.message || 'Failed to fetch admins');
            }

            setTableLoading(true);
        } catch (error) {
            console.error('Fetch error:', error);
            toast.error("Server error while fetching admins");
        }
    };

    const deleteAdmin = async (adminId) => {
        if (!adminId) {
            toast.warn("Something went wrong");
            return;
        }

        try {
            const response = await fetch(`${baseurl}/delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({
                    admin_id: adminId,
                }),
            });

            const result = await response.json();

            if (result.status) {
                toast.success(result.message);
                fetchAssets();
            } else {
                toast.error(result.message || "Failed to create admin.");
            }

        } catch (error) {
            console.error("Error creating admin:", error);
            toast.error("Server error while creating admin.");
        }

        setIsAssetLoading(false);
        // Add delete API call here if needed
    };

    const createAdmin = async () => {
        if (!adminName || !adminEmail || !adminPassword || !confirmPassword) {
            toast.warn("Please fill all the fields");
            return;
        }

        if (adminPassword !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        setIsAssetLoading(true);

        try {
            const response = await fetch(`${baseurl}/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({
                    name: adminName,
                    email: adminEmail,
                    password: adminPassword,
                    user_role: adminRole
                }),
            });

            const result = await response.json();

            if (result.status) {
                toast.success("Admin created successfully!");
                fetchAssets();
                setAdminName('');
                setAdminEmail('');
                setAdminPassword('');
                setConfirmPassword('');
                setAdminRole('Master Admin');
                document.querySelector('#addAssetModal .btn-close').click(); // Close modal
            } else {
                toast.error(result.message || "Failed to create admin.");
            }

        } catch (error) {
            console.error("Error creating admin:", error);
            toast.error("Server error while creating admin.");
        }

        setIsAssetLoading(false);
    };

    return (
        <>
            <Header>
                <Auth onProfileDataFetched={handleProfileDataFetched} />
                <div className="main-content app-content">
                    <div className="container-fluid">
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                            <div>
                                <h4 className="mb-0">Admins</h4>
                            </div>
                            <div className="text-end">
                                <button className='btn btn-success btn-sm' data-bs-toggle="modal" data-bs-target="#addAssetModal">+ Create Admin</button>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-table">
                                    <div className="card-header p-0 d-flex justify-content-between mt-3">
                                        <h3 className="card-title mb-1 text-primary">Admin List</h3>
                                    </div>
                                    <div className="table-responsive country-table">
                                        {tableLoading ? (
                                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3">
                                                <thead>
                                                    <tr>
                                                        <th>Avatar</th>
                                                        <th>Name</th>
                                                        <th>Email</th>
                                                        <th>Role</th>
                                                        <th>Created At</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {adminList.length > 0 ? (
                                                        adminList.map((adminsData, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <img src={"assets/images/profile/profile1.avif"} width={30} alt="profile" className="rounded" />
                                                                </td>
                                                                <td>{adminsData.name || 'N/A'}</td>
                                                                <td>{adminsData.email || 'N/A'}</td>
                                                                <td>{adminsData.user_role || 'N/A'}</td>
                                                                <td>{adminsData.created_at || 'N/A'}</td>
                                                                <td>
                                                                    <button onClick={() => deleteAdmin(adminsData.id)} className="btn btn-sm btn-danger">
                                                                        <i className="fa fa-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr><td colSpan="6" className="text-center">No Data Found</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="text-center p-4">
                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal for Add Admin */}
                <div className="modal fade" id="addAssetModal" tabIndex="-1" aria-labelledby="addAssetModal" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title">Add Admin</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="mt-3">
                                    <label>Name</label>
                                    <input type="text" className="form-control" value={adminName} onChange={(e) => setAdminName(e.target.value)} placeholder="Enter Name" />
                                </div>
                                <div className="mt-3">
                                    <label>Email</label>
                                    <input type="email" className="form-control" value={adminEmail} onChange={(e) => setAdminEmail(e.target.value)} placeholder="Enter Email" />
                                </div>
                                <div className="mt-3">
                                    <label>Password</label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="form-control"
                                            value={adminPassword}
                                            onChange={(e) => setAdminPassword(e.target.value)}
                                            placeholder="Enter Password"
                                        />
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <label>Confirm Password</label>
                                    <div className="input-group">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            className="form-control"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            placeholder="Confirm Password"
                                        />
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        >
                                            <i className={`fa ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                        </button>
                                    </div>
                                    {confirmPassword && (
                                        <div className={`mt-2 small ${adminPassword === confirmPassword ? 'text-success' : 'text-danger'}`}>
                                            <i className={`fa ${adminPassword === confirmPassword ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
                                            {adminPassword === confirmPassword ? ' Passwords match' : ' Passwords do not match'}
                                        </div>
                                    )}
                                </div>
                                <div className="mt-3">
                                    <label>Role</label>
                                    <select className="form-control" value={adminRole} onChange={(e) => setAdminRole(e.target.value)}>
                                        <option value="Master Admin">Master Admin</option>

                                    </select>
                                </div>
                                <div className="mt-4 text-end">
                                    <button onClick={createAdmin} className="btn btn-success" disabled={isAssetLoading}>
                                        {isAssetLoading ? "Loading..." : "Submit"}
                                    </button>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                <ToastContainer />
            </Header>
            <Footer />
        </>
    );
}

export default Admin;
